import React from 'react';
import Markdown from 'markdown-to-jsx';

interface SafeMarkdownProps {
  children: string;
  wrapper?: 'article' | 'div';
}

/**
 * The only way to render user-authored markdown. Raw HTML is never parsed into
 * elements (it would allow stored XSS via <iframe src="javascript:...">,
 * <img onerror=...>), so call sites cannot forget the option.
 */
const SafeMarkdown: React.FC<SafeMarkdownProps> = ({ children, wrapper = 'div' }) => (
  <Markdown options={{ wrapper, disableParsingRawHTML: true }}>{children}</Markdown>
);

export default SafeMarkdown;
